import Vue from 'vue'

/**
 * 获取企业设备统计信息
 * @param {} params
 */
export const getDevStateTotal = (params) => {
  return Vue.fetch.post('/apiv1/hr/device/devStateTotal', params)
}

/**
 * 获取企业设备统计信息
 * @param {} params
 */
export const getEmployeeUpdateTotal = (params) => {
  return Vue.fetch.post('/apiv1/hr/employee/employeeUpdateTotal', params)
}

/**
 * 人员变更详情
 * @param {} params
 */
export const employeeUpdateTotalDetails = (params) => {
  return Vue.fetch.post('/apiv1/hr/employee/employeeUpdateTotalDetails', params)
}

/**
 * 设备变更详情
 * @param {} params
 */
export const devStateTotalDetails = (params) => {
  return Vue.fetch.post('/apiv1/hr/device/devStateTotalDetails', params)
}



// WEBPACK FOOTER //
// ./src/services/enterpriseDashboardApi.js